import React from 'react';
import { toast } from 'react-toastify';
import { I18n } from 'helpers/i18n';
import { MEETING_JOIN_DEEPLINK_DECISION_MS } from './workplaceMeetingConfig';

export const MEETING_JOIN_DEEPLINK_TOAST_ID = 'meeting-join-deeplink-open';

const toastBaseOpts = {
  toastId: MEETING_JOIN_DEEPLINK_TOAST_ID,
  position: 'top-center',
  theme: 'light',
  autoClose: false,
  closeOnClick: false,
  hideProgressBar: true,
  pauseOnHover: true,
  draggable: false,
  className: 'meeting-join-deeplink-toast-outer',
  bodyClassName: 'meeting-join-deeplink-toast-body',
};

function ConnectingBody() {
  return (
    <div className="meeting-join-deeplink-toast">
      <div className="meeting-join-deeplink-toast__line meeting-join-deeplink-toast__line--pending">
        <span className="meeting-join-deeplink-toast__text">
          {I18n.t('meeting_join_deeplink_toast_connecting', {
            defaultValue: 'Connecting to CED Meeting…',
          })}
        </span>
      </div>
    </div>
  );
}

function WaitingBody() {
  return (
    <div className="meeting-join-deeplink-toast">
      <div className="meeting-join-deeplink-toast__line meeting-join-deeplink-toast__line--waiting">
        <span className="meeting-join-deeplink-toast__text">
          {I18n.t('meeting_join_deeplink_toast_waiting_system', {
            defaultValue: 'Waiting for system confirmation…',
          })}
        </span>
      </div>
    </div>
  );
}

function ErrorBody({ onDownloadClick }) {
  const message = I18n.t('meeting_join_deeplink_toast_app_not_found', {
    defaultValue:
      'The app was not found on this computer. It may have been uninstalled.',
  });

  return (
    <div className="meeting-join-deeplink-toast">
      <div
        className="meeting-join-deeplink-toast__line meeting-join-deeplink-toast__line--error"
        role="status"
      >
        <span className="meeting-join-deeplink-toast__text meeting-join-deeplink-toast__text--error">
          {message}
        </span>
      </div>
      <button
        type="button"
        className="meeting-join-deeplink-toast__cta"
        onClick={() => {
          toast.dismiss(MEETING_JOIN_DEEPLINK_TOAST_ID);
          onDownloadClick();
        }}
      >
        {I18n.t('meeting_join_deeplink_toast_download_btn', {
          defaultValue: 'Download installer',
        })}
      </button>
    </div>
  );
}

/**
 * Một toast duy nhất (icon mặc định Toastify): đang kết nối → sau blur chờ hệ thống → đóng nếu tab hidden;
 * hết thời gian mà không blur/hidden và tab vẫn focus → lỗi + nút tải bộ cài.
 * @returns cleanup (gỡ listener + clear timeout)
 */
export function startDeeplinkOpenAppToast(onOpenDownloadModal) {
  toast.dismiss(MEETING_JOIN_DEEPLINK_TOAST_ID);

  let sawBlur = false;
  let sawHidden = false;
  let cleaned = false;
  let timerId = null;

  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    window.removeEventListener('blur', onBlur);
    document.removeEventListener('visibilitychange', onVisibility);
    if (timerId != null) window.clearTimeout(timerId);
  };

  const onBlur = () => {
    if (sawBlur || sawHidden) return;
    sawBlur = true;
    toast.update(MEETING_JOIN_DEEPLINK_TOAST_ID, {
      render: <WaitingBody />,
      type: toast.TYPE.INFO,
      theme: 'light',
      className: 'meeting-join-deeplink-toast-outer',
      bodyClassName: 'meeting-join-deeplink-toast-body',
    });
  };

  const onVisibility = () => {
    if (document.visibilityState !== 'hidden') return;
    sawHidden = true;
    cleanup();
    toast.dismiss(MEETING_JOIN_DEEPLINK_TOAST_ID);
  };

  toast.info(<ConnectingBody />, {
    ...toastBaseOpts,
  });

  window.addEventListener('blur', onBlur);
  document.addEventListener('visibilitychange', onVisibility);

  timerId = window.setTimeout(() => {
    timerId = null;
    cleanup();
    if (sawHidden) return;
    if (sawBlur) {
      toast.dismiss(MEETING_JOIN_DEEPLINK_TOAST_ID);
      return;
    }
    const focused = typeof document.hasFocus === 'function' ? document.hasFocus() : true;
    const visible = document.visibilityState === 'visible';
    if (focused && visible) {
      toast.update(MEETING_JOIN_DEEPLINK_TOAST_ID, {
        render: <ErrorBody onDownloadClick={onOpenDownloadModal} />,
        type: toast.TYPE.ERROR,
        theme: 'light',
        className: 'meeting-join-deeplink-toast-outer',
        bodyClassName: 'meeting-join-deeplink-toast-body',
      });
    } else {
      toast.dismiss(MEETING_JOIN_DEEPLINK_TOAST_ID);
    }
  }, MEETING_JOIN_DEEPLINK_DECISION_MS);

  return cleanup;
}
